<template>
  <div class="card mb-0 shadow"  @click="expand(currentStakeholder.customer.id)">
    <slot></slot>
    <!-- notes on stakeholder -->
    <div v-show="expanded">
      <div class="mt-15">
          <div class="grid2col mt-30">
              <div v-bind:class="{ 'fg-primary': currentView === 'customerNotes' }" @click.stop="currentView = 'customerNotes'" class="select-none">Kundanteckningar</div>
              <div v-bind:class="{ 'fg-primary': currentView === 'objectNotes' }" class="text-right select-none" @click.stop="currentView = 'objectNotes'">Objektanteckningar</div>
          </div>
          <div v-show="currentView === 'customerNotes'" class="mt-15">
            <div v-show="customerNotes.length">
              <div v-for="(note, index) in customerNotes" :key="index" class="mb-15">
                <p class="fg-grey fs-14">{{ note.createdAt }}</p>
                <p>{{ note.content }}</p>
              </div>
            </div>
            <p v-show="!customerNotes.length" class="fg-grey">Inga kundanteckningar.</p>
          </div>

        <div v-show="currentView === 'objectNotes'" class="mt-15">
          <div v-show="objectNotes.length">
            <div v-for="(note, index) in objectNotes" :key="index" class="mb-15">
              <p class="fg-grey fs-14">{{ note.createdAt }}</p>
              <p>{{ note.content }}</p>
            </div>
          </div>
          <p v-show="!objectNotes.length" class="fg-grey">Inga objektanteckningar.</p>
        </div>
        <textarea class="mt-25 width-100 p15"
                  rows="8"
                  :placeholder="currentView === 'customerNotes' ? 'Ny kundanteckning':'Ny objektanteckning'"
                  v-model="newNote"
                  @click.stop>
        </textarea>
        <button class="width-100 outline" @click.stop="saveNote(currentStakeholder.customer.id, currentStakeholder)" :disabled="!newNote.length">
          spara
        </button>


      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'biddingsstakeholdercard',
  props: ["stakeholder", "stakeholdergroup"],
  data() {
    return {
      expanded: false,
      currentView: 'customerNotes',
      customerNotes: [],
      objectNotes: [],
      currentStakeholder : this.stakeholder, // passed as a prop (see above) from currentSingle...
      group: this.stakeholdergroup , // passed as a prop (see above) from currentSingle...
      newNote: ''
    }
  },
  methods: {
    getCustomerNotes(stakeholder, force) {
      // Get customer notes
      if (this.customerNotes.length && !force) {
        return false;
      }

      this.$root.callFasAdApi("/internalapi/note/get-from-customer/customerId/" + stakeholder)
      .then((data) => {
        this.customerNotes = data.data;
      })
      .catch(console.error);

    },
    getObjectNotes(stakeholder, force) {
      // Get object notes
      if (this.objectNotes.length && !force) {
        return false;
      }

      let objectId = this.$route.params.id;
      const endpoint = "/internalapi/note/get-from-object/objectId/" + objectId + "/customerId/" + stakeholder;

      this.$root.callFasAdApi(endpoint)
      .then((data) => {
        this.objectNotes = data.data;
      })
      .catch(console.error);

    },
    expand(stakeholder) {
      this.expanded = !this.expanded;
      this.getCustomerNotes(stakeholder);
      this.getObjectNotes(stakeholder);
    },
    saveNote(customerid){
      if (this.currentView === "customerNotes") {
        // save customer note
        let data = {
          customerId: customerid,
          content: this.newNote
        };
        if (customerid) {
          this.$root.callFasAdApi("/internalapi/note/create-customer-note", "POST", data)
          .then(() => {
            this.getCustomerNotes(customerid, true);
            this.newNote = "";
          })
          .catch(console.error);
        }
      } else {
        // save object note
        let data = {
          "objectId": this.$route.params.id,
          "customerIds": [],
          "content": this.newNote
        };
        this.group.stakeholders.forEach((i) => {
          data.customerIds.push(i.customer.id);
        });

        this.$root.callFasAdApi("/internalapi/note/create-object-note", "POST", data)
        .then(() => {
          this.getObjectNotes(customerid, true);
          this.newNote = "";
        })
        .catch(console.error);
      }
    }
  },
}
</script>
